import {Home, Compass, Play, Library, History, Video, VideoClip, Cut} from '../icon'

const sideData =[
    {
        icon: <Home />,
        name: 'Home',
    },
    {
        icon: <Compass />,
        name: 'Explore',
    },
    {
        icon: <Play />,
        name: 'Subscriptions',
    },
    {
        icon: <Library />,
        name: 'Library',
    },
    {
        icon: <History />,
        name: 'History',
    },
    {
        icon: <Video />,
        name: 'Your videos',
    },
    {
        icon: <VideoClip />,
        name: 'Watch later',
    },
    {
        icon: <Cut />,
        name: 'Your clips',
    },
]

export default sideData